export enum ScreenEventName {
  Home = "Home",
  Search = "Search",
  Explore = "Explore",
  Account = "Account",
  Profile = "Profile",
  MyBids = "My Bids",
  MyBidsLive = "My Bids Live",
  MyBidsWon = "My Bids Won",
  MyBidsClosed = "My Bids Closed",
  MyOrders = "My Orders",
  MyOrdersAll = "My Orders All",
  MyOrdersUnpaid = "My Orders Unpaid",
  MyOrdersPaid = "My Orders Paid",
  Product = "Product",
  CategoryPage = "CategoryPage",
  EventPage = "EventPage"
}
